import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

export function Loading() {
	return (
		<div className="flex items-center justify-center min-h-60">
			<Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} size="large" />
		</div>
	);
}
